import { Col, Container, Row } from "react-bootstrap";
import classes from "./QuickStart.module.scss"
import { UserUIStateContext } from "../store/userUIStateContext";
import { useContext, useEffect, useState } from "react";
import { OrgIdContext, ClientTypes } from "../store/orgId_context";
import LoadingDots from "../components/UI/LoadingDots";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { DDD } from "../lib/ddd/ddd";
import { useNavigate } from "react-router";
import { NotificationManager} from 'react-notifications';

const confirmEmailEndpoint = process.env.REACT_APP_API_ENDPOINT ? process.env.REACT_APP_ORIGIN+ "/auth/confirmuserproperty/email" : window.location.origin + "/auth/confirmuserproperty/email";
const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ConfirmEmailLogged = () => {
    const {clientWizardStep, integrationWizardStep, clientWizardFinished,serverDataLoaded, integrationData} = useContext(UserUIStateContext);
    const {clientType, isTransformer, isIntegrator, sessionInfo, setSessionInfoHandler } = useContext(OrgIdContext);
    const {t} = useTranslation();
    const navigate = useNavigate();

    useEffect(() =>{
        if(sessionInfo?.User?.AccessTiers?.MailVerified){
            //NotificationManager.success("", t("Email already confirmed"));
            //return navigate('/dashboard');
        }
        const ddd = new DDD(apiRequestAddress);
        axios.post(confirmEmailEndpoint, {}, {withCredentials: true}).then(res =>{
            ddd.InvalidateSessionExtensions().then(() => {
                ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                    if(res?.result)
                        setSessionInfoHandler(res.result);
                    //window.location = "@/dashboard";
                    NotificationManager.success("", t("Email confirmed"));
                    navigate('/dashboard');
                });
            });
        }).catch(err => {
            if (err.response && err.response.headers) {
                const errorDetails = err.response.headers['x-error-details'];
                console.error('Error Details:', errorDetails);
            } else {
                console.error('No error details found in the response.');
            }
            //window.location = "@/dashboard";
            //NotificationManager.error("", t("Failed to confirm"));
            navigate('/dashboard');
        });
    }, []);

    return (
        <>
        <Container className={classes["main-wrapper"]} style={{height:"100%"}}>
            <div className="d-flex flex-column h-100 justify-content-center align-items-center w-10">
                <div>{t("Thank your for verifying your e-mail")}</div>
                <div><LoadingDots/></div>
            </div>
        </Container>
        </>
    )
}

export default ConfirmEmailLogged;